import React from "react";
import { CircularProgress } from "@mui/material";

export const Loader = ({ styles }) => {
  return (
    <CircularProgress
      style={{
        minWidth: "20px",
        minHeight: "20px",
        color: "#88C3E1",
        ...styles,
      }}
    />
  );
};
